import { ulid } from 'ulid';
import { z } from 'zod';
/**
 * Ids are opaque, stable forever, and comfortably under the agreement's 128
 * characters (C6). ULIDs rather than sequence integers, specifically so that a
 * data migration cannot renumber a `resource_id` the partner has stored —
 * availability is exclusive per resource, so a reused resource id would silently
 * merge two rooms' calendars.
 */
export const ID_PREFIX = {
    appointment: 'ap',
    client: 'cl',
    service: 'sv',
    resource: 'rs',
    hold: 'hd',
    event: 'ev',
    apiKey: 'ak',
    webhookEndpoint: 'we',
    delivery: 'wd',
    certificate: 'ct',
    product: 'pr',
    staff: 'st',
    /** A line on an appointment or a settlement. */
    line: 'ln',
    /** A preference, allergy or note on a client. */
    preference: 'pf',
    /** A closure on the calendar. */
    blackout: 'bo',
    /** A checkout document. */
    settlement: 'se',
    /** A row in the operator audit trail. */
    audit: 'au',
};
export function newId(prefix) {
    return `${prefix}_${ulid()}`;
}
const idSchema = (prefix) => z.string().regex(new RegExp(`^${prefix}_[0-9A-HJKMNP-TV-Z]{26}$`), `must be a ${prefix}_ id`);
export const AppointmentId = idSchema(ID_PREFIX.appointment);
export const ClientId = idSchema(ID_PREFIX.client);
export const ServiceId = idSchema(ID_PREFIX.service);
export const ResourceId = idSchema(ID_PREFIX.resource);
export const HoldId = idSchema(ID_PREFIX.hold);
/**
 * A tenant id is **not** generated. The partner sends `t_lovespa_frenchtown` on
 * every request (agreement section 2), so the operator chooses it at creation
 * and it is stable forever. It is the one id in the system that is human-legible
 * on purpose.
 */
export const TenantId = z
    .string()
    .regex(/^t_[a-z0-9][a-z0-9_]{1,120}$/, 'must be a t_ slug, lower case');
/**
 * Ids we accept from the partner and hand back untouched. We store them and
 * never parse them (agreement section 2), so the only rule is a length bound.
 */
export const OpaqueRef = z.string().min(1).max(128);
//# sourceMappingURL=ids.js.map